import { ArrowRight } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import founderIMG from "../../assets/hero/image.png";

const founder = {
  name: "R. S. JEYAPAUL",
  role: "Founder",
  experience: 45,
};

const FounderSection = () => {
  const [count, setCount] = useState(0);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    let observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startCounting();
        } else {
          setCount(0);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const startCounting = () => {
    let start = 0;
    let end = founder.experience;
    let duration = 2000;
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      let progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * (end - start) + start));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };

  return (
    <section
      ref={sectionRef}
      className="w-full bg-blue-200 py-12 px-4 sm:px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Founder Card */}
        <div className="flex flex-col">
          <div className="relative overflow-hidden rounded-2xl w-full max-w-md mx-auto">
            <img
              src={founderIMG}
              alt={founder.name}
              className="rounded-2xl self-start h-96 object-cover"
            />

            {/* Name + Role */}
            <div className="flex flex-col justify-center items-start mt-4 p-3">
              <h3 className="text-xl sm:text-2xl font-semibold">{founder.name}</h3>
              <p className="text-gray-500 text-sm sm:text-base">{founder.role}</p>
            </div>
          </div>
        </div>

        {/* Founder Info */}
        <div className="flex flex-col justify-between min-h-[24rem]">
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black mb-4">
              Our Awesome Founder
            </h2>
            <p className="text-gray-600 text-base md:text-lg mb-6">
              Dedicated to innovation, quality, and customer trust <br /> for the
              organization’s strong reputation over four decades.
            </p>
          </div>

          <div className="flex justify-between items-center">
            <div className="flex flex-col justify-center items-start">
              <h3 className="text-7xl font-bold text-black mb-2">{count}+</h3>
              <p className="text-black text-lg mb-6">Years of Experience</p>
            </div>

            {/* Button */}
            <button
              className="relative overflow-hidden inline-flex items-center gap-2 px-6 py-3 sm:py-4 rounded-full text-white bg-[#000615] hover:bg-blue-500 font-medium group transition-colors duration-300"
              onClick={() => navigate("/founder")}
            >
              <span className="relative z-10 flex items-center gap-2">
                <span className="relative block overflow-hidden h-6">
                  <span className="block transition-transform duration-300 transform group-hover:-translate-y-full">
                    Know More
                  </span>
                  <span className="absolute top-full left-0 w-full block text-white transition-transform duration-300 transform group-hover:-translate-y-full">
                    Know More
                  </span>
                </span>
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
